import { forwardRef } from "react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";

import {
  type TAccordionTriggerElement,
  type TAccordionTriggerProps,
} from "@/ui/components/data-display/Accordion/Accordion.config";
import {
  AccordionHeader,
} from "@/ui/components/data-display/Accordion/AccordionHeader";
import {
  AccordionTriggerIcon,
} from "@/ui/components/data-display/Accordion/AccordionTriggerIcon";
import { cn } from "@/ui/lib/utils";
import { TextSubtitle } from "../../typography/TextSubtitle";

export const AccordionTrigger = forwardRef<TAccordionTriggerElement, TAccordionTriggerProps>(
  (
    {
      children,
      className,
      ...props
    },
    ref,
  ) => (
    <AccordionHeader>
      <AccordionPrimitive.Trigger
        data-component="AccordionTrigger"
        ref={ref}
        className={cn(
          "flex flex-1 items-center justify-between gap-4 py-4 px-2 text-left font-sys-default text-foreground transition-colors",
          "appearance-none border-0 bg-transparent",
          "rounded-sys-md",
          "disabled:cursor-not-allowed disabled:opacity-50",
          "focus:outline-none focus-visible:outline-none",
          className,
        )}
        {...props}
      >
        <TextSubtitle tag="span" size={3}>{ children }</TextSubtitle>
        <AccordionTriggerIcon />
      </AccordionPrimitive.Trigger>
    </AccordionHeader>
  ),
);

AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;
